import { dateFormat } from "@/util/date"
import { getDictionary } from "@/api/system/dictbiz"
import pdf417 from '@/components/pdf417/index'
import { mapGetters } from "vuex";
import { getPublishListDept } from '@/api/order/index'
export default {
    props: {
        info: {
            type: Object,
            default: () => {}
        }
    },
    watch: {
        info: {
            deep: true,
            handler(val) {
                this.obj = this.info
            }
        }
    },
    components: {
        pdf417
    },
    data() {
        return {
            awarList: [],
            workTypeList: [],
            visitTypeList:[],
            pzTypeList: [],
            pdfImg: '',
            img: '',
            active: '',
            obj: {},
            deptName: '',
        }
    },
    computed: {
        ...mapGetters(["userInfo"]),
        getValues() {
            return function(list, type) {
                if (!list || list.length == 0) return ''
                let obj = list.find(v => v.dictKey == type);
                return obj ? obj.dictValue : ""
            }
        },
        getDateFormate() {
            return function(date) {
                if (date) {
                    return dateFormat(new Date(date), "yyyy-MM-dd")
                } else {
                    return dateFormat(new Date(), "yyyy-MM-dd hh:mm:ss")
                }
            }
        }
    },
    mounted() {
        this.obj = this.info
        getDictionary({ code: "work_type" }).then(res => {
            this.workTypeList = res.data.data
        })
        getDictionary({ code: "document_type" }).then(res => {
            this.pzTypeList = res.data.data
        })
        getDictionary({ code: "visit-tracking_method" }).then(res => {
            this.visitTypeList = res.data.data
        })
        getPublishListDept().then(res => {
            this.deptName = res.data.data.find(v => v.id == this.userInfo.dept_id).deptName
        })
    },
    methods: {
        strInit(str) {
            // 这里模拟后台返回的字符串
            let newStr = str.substring(str.length - 8)
            let newStr1 = str.substring(0, str.length - 8)
            var replaceString = '<span style="color: red;">' + newStr + "</span>"
            // str = str.replace(new RegExp(newStr, 'g'), replaceString)
            this.number = newStr1 + replaceString
            return newStr1 + replaceString
        },
        getStatusList() {
            getDictionary({ code: "order_status" }).then(res => {
                const column = this.findObject(this.option.column, "starOrderStatusList");
                let list = res.data.data.filter(v => v.dictKey <= 100)
                column.dicData = list
            })
        },
        getLabel(data, type) {
            let item = null
            if (type == 'document_type') {
                if (!this.pzTypeList || this.pzTypeList.length == 0) return ""
                item = this.pzTypeList.find(v => v.dictKey == data);
            } else if (type == 'visit-tracking_method') {
                if (!this.visitTypeList || this.visitTypeList.length == 0) return ""
                item = this.visitTypeList.find(v => v.dictKey == data);
            } else {
                if (!this.workTypeList || this.workTypeList.length == 0) return ""
                item = this.workTypeList.find(v => v.dictKey == data);
            }
            return item ? item.dictValue : ""
        },
        getImagePdf417(res) {
            this.pdfImg = res
        },
        printHandle() {
            this.img = ""
            this.$print(this.$refs.wrap)
        },
        closeHandle() {
            this.pdfImg = ""
            this.$emit("close")
        },
        getFilterReault(arg, id) {
            if (arg.id == id) {
                this.tempArr = arg.title
            } else {
                if (arg.children instanceof Array && null != arg.children) {
                    for (let child of arg.children) {
                        this.getFilterReault(child, id)
                    }
                }
            }

        },
        getDeptName(list, id) {
            this.tempArr = ""
            for (let item of list) {
                this.getFilterReault(item, id)
            }
            return this.tempArr
        }
    }
};
